import { useEffect, useState } from "react";

function preloadImage(image: Picture) {
  const img = new Image();
  img.sizes = "100vw";
  img.srcset = image.sources[0]?.srcset ?? image.srcset ?? "";
  img.src = image.src;
}

export default function useLightbox<T extends { image: Picture }>(
  items: T[],
  createUrl: (T) => string
): [T, (shown: T) => void, (offset: number) => void] {
  const [shownItem, setShownItem] = useState<T | null>(null);

  const setShownItemAndUpdateUrl = (item: T) => {
    if (item !== shownItem) {
      setShownItem(item);
      if (item) {
        const url = createUrl(item);
        history.replaceState(null, "", url);
      } else {
        history.replaceState(null, "", "#");
      }
    }
  };

  const navigate = (offset: number) => {
    let index = (items.indexOf(shownItem) + offset) % items.length;
    while (index < 0) {
      index += items.length;
    }
    setShownItemAndUpdateUrl(items[index]);
  };

  useEffect(() => {
    const toShow = items.filter((i) => createUrl(i) == window.location.hash)[0];
    if (window.location.hash && toShow) {
      setShownItem(toShow);
    } else {
      setShownItem(null);
    }
  }, [createUrl, items]);

  useEffect(() => {
    if (!shownItem || items.length < 2) {
      return;
    }
    const index = items.indexOf(shownItem);
    const next = items[(index + 1) % items.length];
    const previous = items[(index - 1 + items.length) % items.length];
    preloadImage(next.image);
    preloadImage(previous.image);
  }, [shownItem, items]);

  return [shownItem, setShownItemAndUpdateUrl, navigate];
}
